import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../ExperimentContext/types';
import { useExperiment } from '../ExperimentContext/useExperiment';

export const DesktopTopNavExperiment = makeExperimentWithData(
  'onion-490-desktop-top-nav',
  createValidator<undefined | { variant: number }>(),
);

export const useDesktopTopNav = () => {
  const experiment = useExperiment(DesktopTopNavExperiment);
  return experiment.data?.variant !== undefined;
};
